if(!customElements.get('blog-articles')) {
  class BlogArticles extends HTMLElement {
    constructor() {
      super()
      this.section = this.dataset.sectionId
      this.enableTypes = true
      this.infiniteLoad = JSON.parse(this.dataset.infiniteLoad)
      this.blogFilter = document.querySelector('blog-filter') || null
      this.settings = JSON.parse(this.querySelector('script').textContent)
      this.blogs = this.settings.blog_handles.split(',')
      this.filterTags = this.settings.filter_tags.split(',')
      this.container = this.querySelector('.blog-articles')
      this.activeType = this.settings.filter_type
      this.posts = null
      this.loadMore = this.querySelector('.load-more')
      this.nextIndex = 0
    }
    connectedCallback() {
      this.getPosts()
    }
    getPosts() {
      const fetchRequests = [];
      // default pagination based on blog-articles-api section
      const defaultPagination = 50

      for (const blog of this.blogs) {
        const [handle, articlesCount] = blog.split('$');
        const totalPages = Math.ceil(articlesCount / defaultPagination);
        const fetchUrls = [];

        for (let currentPage = 1; currentPage <= totalPages; currentPage++) {
          const pageParams = `page=${currentPage}`;
          const path = `/blogs/${handle}`;
          const fetchUrl = `${path}/?section_id=blog-articles-api&${pageParams}`;
          fetchUrls.push(fetchUrl);
        }
        const fetchPromises = fetchUrls.map((url) => fetch(url));
        fetchRequests.push(Promise.all(fetchPromises));
      }
      Promise.all(fetchRequests)
        .then((responsesArray) => Promise.all(responsesArray.flat().map((response) => response.text())))
        .then((texts) => {
          const postsArr = []
          texts.forEach((text) => {
            const getArticles = new DOMParser().parseFromString(text, 'text/html').querySelector('.blog-articles').children;
            postsArr.push(...getArticles)
          });
          this.posts = this.sortPosts(postsArr)
          const posts = postsArr.slice()
          this.renderPosts(this.sortPosts(posts))

        })
        .catch((error) => {
          console.error(error);
        }); 
    }
    sortPosts(arr) {
      const articles = arr.sort((a, b) => {
        const dateA = new Date(a.getAttribute('data-post-date'))
        const dateB = new Date(b.getAttribute('data-post-date'))
        return dateB - dateA
      })
      return articles
    }
    filterPosts(arr,type,tag) { 
      let filteredArticles = arr
      let articles = arr.slice()

      // By content type
      if (type !== 'all' && type !== '' && type !== false) {
        filteredArticles = articles.filter(
          (article) => article.dataset.postType === type
        );
      }
      // By article tag
      if(this.filterTags.length > 0 && this.filterTags[0] !== '' || tag !== null) {
        let tags = this.filterTags
        if(tag !== null) { 
          tags = tag.split( )
        }
        // need to update tags
        filteredArticles = filteredArticles.filter(((article) => {
          let articleTags = article.getAttribute('data-post-tags').split(',')
          return tags.every((tag) => articleTags.includes(tag))
        }))
      }
      return filteredArticles
    }
    renderPosts(arr) { 
      const posts = this.filterPosts(arr,this.activeType,null)
      if(posts.length === 0) { 
        this.noResults()
      } else { 
        const initialPosts = this.container.querySelector('.article')
        if(!initialPosts && posts.length > 0) { 
          this.loadInitialPosts(posts)
          this.querySelector('.blog-articles__loading').classList.add('hidden')
        } else if(initialPosts.length > 0 && initialPosts.length < posts.length) {
          this.loadInitialPosts(posts)
        } 
      }
      this.onIntersectionObserver(arr)
    }
    noResults() { 
      this.querySelector('.blog-articles__loading').classList.add('hidden')
      this.querySelector('.no-posts').classList.remove('hidden')
    }
    loadNextPosts(arr) { 
      const adverts = this.container.querySelectorAll('.advert')
      const totalPosts = adverts.length > 0 ? this.container.children.length - adverts.length : this.container.children.length
      const startIndex = totalPosts
      const endIndex = startIndex + this.settings.load_more
      const posts = this.filterPosts(arr,this.activeType,null)
      if(posts === undefined || posts === null) { 
        return
      }
      const nextPosts = posts.slice(startIndex,endIndex) 
      this.updatePosts(nextPosts,false);
      this.nextIndex = endIndex;

      if (this.nextIndex >= posts.length) {
        if (this.onIntersectionObserver && this.onIntersectionObserver.observer) {
          this.onIntersectionObserver.observer.disconnect();
        }
      }
    }
    loadInitialPosts(arr) { 
      const initialPosts = arr.slice(0,this.settings.load_more)
      this.updatePosts(initialPosts,true)
      this.container.classList.remove('no-borders')
    }
    onIntersectionObserver(arr) {
      const observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            this.loadNextPosts(arr);
          }
        }
      })
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.7, 
      }
      if(this.loadMore !== null || this.loadMore != undefined) {
        observer.observe(this.loadMore, options);
      }
    }
    updatePosts(arr,initial) { 
      let articles = arr
      if(articles === null || articles === undefined) { 
        this.container.innerHTML = `
          <p class="padding-all no-posts">
            ${window.generalStrings.noResults.replace('{{ type }}','')}
          </p>
        `
        return
      }
      if(initial) {
        this.container.innerHTML = ''
        const container = document.createElement('div')
        articles = articles.slice(0,this.settings.pagination)
        articles.forEach(article => { 
          this.stylePost(article)
          container.appendChild(article)
        })
        if(articles.length > 0) { 
          this.container.innerHTML = container.innerHTML
        } else { 
          this.container.innerHTML = `
          <p class="padding-all no-posts">
            ${window.generalStrings.noResults.replace('{{ type }}','')}
          </p>
          `
          return
        }
      } else {
        const fragment = document.createDocumentFragment()

        articles.forEach((post) => {
          this.stylePost(post)
          fragment.appendChild(post)
        })
        // Insert the new posts after the last existing post
        const lastPost = this.container.lastElementChild
        this.container.insertBefore(fragment, lastPost.nextSibling)
        generateBorders()
      }
    }
    stylePost(post) { 
      const main = post.querySelector('.blog-post__main')
      const image = post.querySelector('.blog-post__image')
      const container = post.querySelector('.blog-post__container')
      const title = post.querySelector('.blog-post__title a')

      if (this.settings.full_width) {
        post.classList.add('full-width')
      }
      if (this.settings.posts_per_row === 1) {
        if (this.settings.show_container === false) {
          main.classList.remove('container--bg')
        }
        main.classList.remove('has-image')
        title.classList.remove('link--secondary')
        container.classList.remove('absolute')

        if (image !== null) {
          main.classList.add('grid-cols-4')
          main.classList.add('grid')

          if(this.settings.show_overlay) { 
            image.classList.add('image--overlay')
          } else { 
            image.classList.remove('image--overlay')
          }

          image.classList.add(this.settings.aspect_ratio)
          image.classList.add('grid-col-1')
          container.classList.add('grid-col-2-span-3')
        } else {
          main.classList.add('grid-cols-3')
          container.classList.add('grid-col-1-span-3')
        }
      } else {
        if (this.settings.show_container === false) {
          main.classList.remove('container--bg')
        }
        if (this.settings.image_as_bg) {
          if (image !== null) {
            image.classList.add(this.settings.aspect_ratio)
            main.classList.add('has-image')
            container.classList.add('absolute')
            image.classList.remove('image--overlay')
            if(this.settings.show_overlay) { 
              image.classList.add('image--overlay')
            }
          }
        } else {
          main.classList.remove('has-image')
          container.classList.remove('absolute')
          title.classList.remove('link--secondary')
          if (image !== null) {
            image.classList.remove(this.settings.aspect_ratio)
            main.classList.remove(this.settings.aspect_ratio)
            image.classList.add(this.settings.aspect_ratio)
            image.classList.remove('image--overlay')
            if(this.settings.show_overlay) { 
              image.classList.add('image--overlay')
            }
          }
        }
      }
    }
  }
  customElements.define('blog-articles', BlogArticles)
}